module.exports = __webpack_public_path__ + "static/img/icon-configActive.3c3313c8.png";